import QuickLinksPattern from "./quickLinks";

export default QuickLinksPattern;
